import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam, useParseParams } from '@hooks/params';
import { findCarQuoteParamsSchema } from '@apis/CarQuoteApi';

import {
  carQuoteFetch,
  CarQuoteFetchPayload,
  carQuoteFind,
  CarQuoteFindPayload,
} from './action';
import { selectCarQuoteBuy } from './selector';
import { CarQuoteBuyNewPageParams } from './route';

export const useCarQuoteBuyNewPageParams = () => useParseParams<CarQuoteBuyNewPageParams>(findCarQuoteParamsSchema);

export const useCarQuoteFind = (payload: CarQuoteFindPayload) => {
  const dispatch = useDispatch();
  const { carQuote } = useSelector(selectCarQuoteBuy);
  useEffectOnce(() => {
    dispatch(carQuoteFind(payload));
  });
  return carQuote;
};

export const useCarQuoteFetch = () => {
  const dispatch = useDispatch();
  const orderNumber = useRouteParam('orderNumber') as string;
  const { carQuote } = useSelector(selectCarQuoteBuy);

  useEffectOnce(() => {
    const payload: CarQuoteFetchPayload = { orderNumber };
    dispatch(carQuoteFetch(payload));
  });

  return carQuote;
};
